import { useEffect, useRef } from "react";
import Lenis from "lenis";

/**
 * Global smooth momentum scrolling. Skips /admin routes so heavy editor UI stays snappy.
 */
export default function SmoothScroll({ children, disabled = false }) {
  const rafRef = useRef();
  const lenisRef = useRef();

  useEffect(() => {
    if (disabled) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4,
    });
    lenisRef.current = lenis;
    const raf = (time) => {
      lenis.raf(time);
      rafRef.current = requestAnimationFrame(raf);
    };
    rafRef.current = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafRef.current);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, [disabled]);

  return children;
}
